export default "__VITE_ASSET__PMdsa5sW__"